import React, { useEffect, useState } from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
  TwitterIcon,
  TwitterShareButton
} from 'react-share';
import PropTypes from 'prop-types';
import styled, { css, withTheme } from 'styled-components';

const SCROLL_OFFSET = 400;

const Container = styled.div`
  position: fixed;
  bottom: 1em;
  left: 1em;
  display: flex;
  pointer-events: none;
  z-index: 3;
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.2s ease-out;

  @media (min-width: 768px) {
    flex-direction: column;
    transform: translateX(-100%);
  }

  ${props =>
    props.active &&
    css`
      opacity: 1;
      transform: translate(0, 0) !important;
    `}

  & > * {
    pointer-events: auto;

    &:not(:first-child) {
      margin-left: 1em;

      @media (min-width: 768px) {
        margin: 1em 0 0;
      }
    }
  }
`;

const SocialButtons = ({ theme, shareTitle, shareUrl }) => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const $el = document.getElementById('content');
    let isRunning;

    const handleScroll = () => {
      if (!isRunning) {
        isRunning = window.requestAnimationFrame(() => {
          setScrollTop($el.scrollTop);
          isRunning = null;
        });
      }
    };

    $el.addEventListener('scroll', handleScroll);
    return () => $el.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Container active={scrollTop > SCROLL_OFFSET}>
      <TwitterShareButton title={shareTitle} url={shareUrl}>
        <TwitterIcon iconBgStyle={{ fill: theme.primary }} round size="2.5em" />
      </TwitterShareButton>
      <FacebookShareButton quote={shareTitle} url={shareUrl}>
        <FacebookIcon
          iconBgStyle={{ fill: theme.primary }}
          round
          size="2.5em"
        />
      </FacebookShareButton>
      <LineShareButton title={shareTitle} url={shareUrl}>
        <LineIcon iconBgStyle={{ fill: theme.primary }} round size="2.5em" />
      </LineShareButton>
    </Container>
  );
};

SocialButtons.propTypes = {
  shareUrl: PropTypes.string.isRequired,
  shareTitle: PropTypes.string.isRequired
};

export default withTheme(SocialButtons);
